module.exports = __webpack_public_path__ + "img/30f13.93a739a6.jpg";